module.exports = __webpack_public_path__ + "static/media/anymeets_placeholder.61538a06.svg";